module.exports = __webpack_public_path__ + "img/text.8e0fe27d.svg";